import React, { Component } from 'react';
import {Card,CardBody,CardTitle,Col,Row} from 'reactstrap';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import { app } from '../../base'

const MyMapComponent = withScriptjs(withGoogleMap((props) =>
  <GoogleMap
    ref={props.onMapLoad}
    defaultZoom={15}
    center={{ lat: props.lat, lng: props.long }}>
  {/*<Marker position={{ lat: props.markers[0].lat, lng: props.markers[0].long }} />*/}
    {props.markers.map((marker,idx) => (
      <Marker key={idx} {...marker}/>
    ))}
  </GoogleMap>
))

class Maps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markers: [],
      user_lat: 41.015137,
      user_long: 28.979530
    }
    this.getPosition = this.getPosition.bind(this);
  }

  componentWillMount() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.getPosition);
    }

    app.database().ref('users').orderByChild('user_type').equalTo(2).once('value')
    .then((snapshot)=>{
      let markers = [];
      snapshot.forEach((child)=>{
        let data = child.val();
        let position = data.position || '0,0';
        position = position.split(',');
        markers.push({
          position: {
            lat: parseFloat(position[0]),
            lng: parseFloat(position[1])
          },
          title: data.shop_name || ''
        });
      });

      this.setState({markers});
    });
  }

  getPosition(position){
    //console.log("Latitude: " + position.coords.latitude + ", Longitude: " + position.coords.longitude);
    this.setState({
      user_lat: position.coords.latitude,
      user_long: position.coords.longitude
    });
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <MyMapComponent
                  isMarkerShown
                  lat={this.state.user_lat}
                  long={this.state.user_long}
                  markers={this.state.markers}
                  googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCifT6al-HiUFHGP16VYdNAl33vzyx5Rao&v=3.exp&libraries=geometry,drawing,places"
                  loadingElement={<div style={{ height: `400px` }} />}
                  containerElement={<div style={{ height: `400px` }} />}
                  mapElement={<div style={{ height: `400px` }} />}/>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default Maps;


// WEBPACK FOOTER //
// ./src/views/Locations/Maps.js